import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/Hero';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function InstagramAdsPage() {
  useEffect(() => {
    // Add noindex meta tag dynamically
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute('content', 'noindex, nofollow');
    return () => {
      if (metaRobots) {
        metaRobots.setAttribute('content', 'index, follow');
      }
    };
  }, []);
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-705">
      
      <Navigation data-id="element-706" />

      <main data-id="element-707">
        <Hero data-id="element-708" />
        <Consultation data-id="element-709" />
      </main>

      <Footer data-id="element-710" />
      <CookieBanner data-id="element-711" />
      <FloatingContact data-id="element-712" />
    </div>;
}